import { useEffect } from "react";
import { useStoreActions } from "stores";

export const useThemeManager = () => {
  const { initializeTheme } = useStoreActions((actions) => actions.theme);

  useEffect(() => {
    initializeTheme();
  }, [initializeTheme]);

  return null;
};
